import {
  Button,
  Checkbox,
  Collapse,
  Form,
  Input,
  message,
  Radio,
  Select,
  Typography,
} from "antd";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateExpensePolicies,
  create_expense_policies,
  EditExpensePolicies,
  edit_expense_policies,
  expense_policies_list,
} from "../../../../actions/expenses/expenses";
import * as yup from "yup";
import { MinusCircleOutlined } from "@ant-design/icons";
const { Panel } = Collapse;

//  import { validationRules } from '../../../utils';
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;

const ValidationSchema = yup.lazy((values) =>
  yup.object().shape({
    name: yup.string().required(),
    description: yup.string(),
    conditions: yup
      .array()
      .of(
        yup.object().shape({
          field: yup.string().required(),
          data: yup.mixed().when("field", {
            is: "bill_attached",
            then: yup.boolean().required(),
            otherwise: yup.array().of(
              yup.object().shape({
                amount: yup.string().required(),
                condition: yup.string().required(),
              }),
            ),
          }),
        }),
      )
      .compact((v) => {
        if (v.field === "bill_attached") {
          return v.data === "" ? false : true;
        }
      }),
    action: yup.mixed().required(),
    employee_ids: yup
      .array()
      .of(yup.string())
      .test("employee_ids", "Rule is required", () => {
        if (
          values.employee_ids?.length === 0 &&
          !values.designation_id &&
          !values.cost_center_id &&
          !values.project_id
        ) {
          return false;
        }
        return true;
      }),
  }),
);

const AddExpense = (props) => {
  const dispatch = useDispatch();
  const cardPoliciesRes = useSelector((state) => state?.cards?.cardPolicies);
  const createRes = useSelector((state) => state?.expenses?.create_policies);
  const editRes = useSelector((state) => state?.expenses?.edit_policies);
  const [chan_key, set_chan_key] = useState("employee_ids");
  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      employee_ids: [],
      is_blocked: "",
      is_warning: "",
      action: "",
      type: "expense", // report
      conditions: [
        {
          field: "",
          data: [
            {
              amount: "",
              condition: "",
            },
          ],
        },
      ],
      designation_id: "",
      cost_center_id: "",
      project_id: "",
      bill_attached: false,
    },
    validationSchema: ValidationSchema,
    onSubmit: (vals) => {
      if (vals.designation_id && chan_key === "designation_id") {
        delete vals.employee_ids;
        delete vals.cost_center_id;
        delete vals.project_id;
      }
      if (vals.cost_center_id && chan_key === "cost_center_id") {
        delete vals.employee_ids;
        delete vals.designation_id;
        delete vals.project_id;
      }
      if (vals.project_id && chan_key === "project_id") {
        delete vals.employee_ids;
        delete vals.designation_id;
        delete vals.cost_center_id;
      }
      if (vals.employee_ids?.length && chan_key === "employee_ids") {
        delete vals.designation_id;
        delete vals.cost_center_id;
        delete vals.project_id;
      }
      delete vals.action;
      if (vals.conditions?.length > 0) {
        vals.type = "expense";
        vals.conditions.forEach((ele) => {
          if (ele.field === "report_total") {
            vals.type = "report";
            return;
          }
        });
      }
      if (vals.id) {
        delete vals.data;
        delete vals.field;
        delete vals.expense_policy_users;
        delete vals.condition_data;
        delete vals.expense_policy_fields;
        vals.expense_policy_id = vals.id;
        delete vals.id;
        dispatch(edit_expense_policies({ expense_policy: vals }));
      } else {
        dispatch(create_expense_policies({ expense_policy: vals }));
      }
    },
  });
  const key_map = {
    employee_ids: "users",
    designation_id: "grade_designation",
    cost_center_id: "cost_centers",
    project_id: "projects",
  };
  useEffect(() => {
    if (createRes?.data?.status || editRes?.data?.status) {
      dispatch(expense_policies_list());
      props.handleCancel();
      formik.resetForm();
      dispatch({
        type: CreateExpensePolicies.RESET,
      });
      dispatch({
        type: EditExpensePolicies.RESET,
      });
      // message.success(
      //   <span className="messageText">{createRes.data?.message || editRes.data?.message}</span>
      // );
    }

    if (createRes?.data?.status === false) {
      dispatch({
        type: CreateExpensePolicies.RESET,
      });
    }

    if (editRes?.data?.status === false) {
      dispatch({
        type: EditExpensePolicies.RESET,
      });
    }
    // eslint-disable-next-line
  }, [createRes, editRes]);

  useEffect(() => {
    if (props.selectedRow?.id) {
      let fieldsData = props.selectedRow.condition_data.map((ele) => ({
        field: Object.keys(ele)?.[0],
        data: ele[Object.keys(ele)?.[0]],
      }));
      const bill_attached = fieldsData?.find?.(
        (ele) => ele?.field === "bill_attached",
      )?.data;
      formik.setValues({
        ...props.selectedRow,
        bill_attached,
        conditions: props.selectedRow.condition_data.map((ele) => ({
          field: Object.keys(ele)?.[0],
          data: ele[Object.keys(ele)?.[0]],
          // employee_ids: [props.selectedRow?.expense_policy_users?.[0]?.id] || [],
          designation_id: props.selectedRow?.designation_id || "",
          cost_center_id: props.selectedRow?.cost_center_id || "",
          project_id: props.selectedRow?.project_id || "",
          action: "act",
        })),
      });
      if (props.selectedRow?.expense_policy_users?.length > 0) {
        set_chan_key("employee_ids");
        formik.setFieldValue("employee_ids", [
          props.selectedRow?.expense_policy_users?.[0]?.id,
        ]);
      }
      if (props.selectedRow?.designation_id) {
        set_chan_key("designation_id");
      }
      if (props.selectedRow?.cost_center_id) {
        set_chan_key("cost_center_id");
      }
      if (props.selectedRow?.project_id) {
        set_chan_key("project_id");
      }
      formik.setFieldValue("action", "actions");
    } else {
      formik.resetForm();
    }
    // eslint-disable-next-line
  }, [props.selectedRow]);

  const handleCancelButton = () => {
    formik.resetForm();
    props.handleCancel();
  };

  return (
    <>
      <Form
        layout="vertical"
        // form={form}
        onFinish={formik.handleSubmit}
        className="modal-form"
      >
        <Form.Item label="Policy Name" required={true}>
          <Input
            placeholder="Default Policy"
            onChange={formik.handleChange}
            name="name"
            value={formik.values.name}
          />
          {formik.touched.name && (
            <div className="errorMsg">{formik.errors.name}</div>
          )}
        </Form.Item>
        <Form.Item label="Description">
          <TextArea
            placeholder="Enter Description (Optional)"
            autoSize={{ minRows: 3, maxRows: 5 }}
            onChange={formik.handleChange}
            value={formik.values.description}
            name="description"
          />
        </Form.Item>
        <div className="dividerText">Define Conditions for this policy</div>
        <Form.Item name="checkboxGroup" style={{ marginBottom: "5px" }}>
          <Collapse
            accordion
            className="customCollapse"
            defaultActiveKey={["1"]}
          >
            <Panel header={<b>Define the Users ( if any )</b>} key="1">
              <Text>Choose who will be affected by this rule.</Text>
              <div className="viewPolicyCards">
                1<div className="darkbox">Rule will apply to</div>
                <div className="lightbox">
                  <Select
                    placeholder="Select "
                    onChange={(val) => {
                      formik.setFieldValue(
                        chan_key,
                        chan_key === "employee_ids" ? [] : "",
                      );
                      set_chan_key(val);
                    }}
                    value={chan_key}
                  >
                    <Option value="employee_ids">Specific user</Option>
                    <Option value="designation_id">
                      Specific Grade/Designation
                    </Option>
                    <Option value="cost_center_id">Cost Center</Option>
                    <Option value="project_id">Project</Option>
                  </Select>
                </div>
                <div className="lightbox">
                  <Select
                    placeholder="Select "
                    onChange={(val) => {
                      formik.setFieldValue(
                        chan_key,
                        chan_key === "employee_ids" ? [val] : val,
                      );
                    }}
                    showSearch
                    filterOption={(input, option) => {
                      return option?.children
                        ?.toLowerCase()
                        ?.includes(input?.toLowerCase());
                    }}
                    value={
                      chan_key === "employee_ids"
                        ? formik.values[chan_key]?.[0]
                        : cardPoliciesRes?.data?.response?.[
                            key_map[chan_key]
                          ]?.find((ele) => ele.id === formik.values[chan_key])
                            ?.id
                    }
                  >
                    {(() => {
                      let options =
                        cardPoliciesRes?.data?.response?.[key_map[chan_key]] ||
                        [];
                      // If editing a policy with a specific user, ensure that user is in the options list
                      if (
                        chan_key === "employee_ids" &&
                        props.selectedRow?.id &&
                        props.selectedRow.expense_policy_users?.length > 0
                      ) {
                        const selectedUser =
                          props.selectedRow.expense_policy_users[0];
                        if (
                          !options.some((opt) => opt.id === selectedUser.id)
                        ) {
                          // Create a new array with the selected user prepended to avoid mutation
                          options = [selectedUser, ...options];
                        }
                      }
                      return options.map((ele) => (
                        <Option value={ele.id} key={ele.id}>
                          {ele.title || ele.name || ele.email}
                        </Option>
                      ));
                    })()}
                  </Select>
                </div>
              </div>
            </Panel>
            <div className="errorMsg">
              {formik.touched.employee_ids && formik.errors.employee_ids}
            </div>
          </Collapse>
        </Form.Item>
        <Collapse accordion className="customCollapse" defaultActiveKey={["3"]}>
          <Panel header={<b>Define the limit ( if any )</b>} key="3">
            <Text>Create limits for this rule.</Text>
            {formik?.values?.conditions?.map((ele, i) => (
              <>
                <div className="viewPolicyCards">
                  {i + 1}
                  <div className="darkbox">When</div>
                  <Select
                    placeholder="Select "
                    onChange={(val) => {
                      formik.setFieldValue(`conditions[${i}].field`, val);
                      if (val === "bill_attached") {
                        formik.setFieldValue(`conditions[${i}].data`, true);
                        formik.setFieldValue(`bill_attached`, true);
                      } else {
                        formik.setFieldValue(`conditions[${i}].data`, [
                          {
                            amount: "",
                            condition: "",
                          },
                        ]);
                      }
                    }}
                    value={formik.values.conditions[i].field}
                  >
                    <Option value="expense_amount">Expense amount</Option>
                    <Option value="report_total">Report total</Option>
                    {(!formik?.values?.bill_attached ||
                      formik.values.conditions[i].data === true) && (
                      <Option value="bill_attached">Bill Mandatory</Option>
                    )}
                  </Select>
                  {formik.values.conditions?.[i]?.field !== "bill_attached" ? (
                    <>
                      <div className="darkbox">For</div>
                      <Select
                        placeholder="Select "
                        onChange={(val) =>
                          formik.setFieldValue(
                            `conditions[${i}].data[0].condition`,
                            val,
                          )
                        }
                        value={
                          formik.values.conditions?.[i]?.data?.[0]?.condition
                        }
                      >
                        <Option value="<">Less than</Option>
                        <Option value=">">Greater than</Option>
                        <Option value="<=">Less than or equal</Option>
                        <Option value=">=">Greater than or equal</Option>
                        <Option value="!=">Not equal</Option>
                      </Select>
                    </>
                  ) : null}
                </div>
                {formik.values.conditions?.[i]?.field !== "bill_attached" && (
                  <div className="viewPolicyCards">
                    Amount
                    <Input
                      name="amount"
                      onChange={(e) => {
                        if (Number.isNaN(Number(e.target.value))) {
                          return;
                        }
                        formik.setFieldValue(
                          `conditions[${i}].data[0].amount`,
                          e.target.value,
                        );
                      }}
                      value={formik.values.conditions?.[i]?.data?.[0]?.amount}
                    />
                    {i > 0 && (
                      <MinusCircleOutlined
                        className="ml3 cursor"
                        onClick={() => {
                          let conditions = formik.values.conditions;
                          conditions.splice(i, 1);
                          formik.setFieldValue("conditions", conditions);
                        }}
                      />
                    )}
                  </div>
                )}
              </>
            ))}
            <Button
              type="default"
              ghost
              className="approve-add-btn mt1"
              onClick={() => {
                formik.setFieldValue(`conditions`, [
                  ...formik.values.conditions,
                  {
                    field: "",
                    data: [
                      {
                        amount: "",
                        condition: "",
                      },
                    ],
                  },
                ]);
              }}
            >
              + Add one more
            </Button>
            <div className="errorMsg">
              {formik.touched.conditions &&
                formik.errors.conditions?.length > 0 &&
                "Expense Limit should not be empty"}
            </div>
          </Panel>
        </Collapse>
        <Collapse accordion className="customCollapse" defaultActiveKey={["4"]}>
          <Panel header={<b>Actions</b>} key="4" className="expensePanel">
            {/* <div>
              <Checkbox name="bill_attached" checked={formik.values.bill_attached} onChange={(e) => {
                formik.setFieldValue("bill_attached", e.target.checked)
              }}>
                <Text>
                  Is Bill Mandatory
                </Text>
              </Checkbox>
            </div> */}
            <div>
              <Text>
                Select the actions you want to occur when the rule applies.
              </Text>
              <Radio
                name="action"
                checked={formik.values.is_blocked}
                onChange={(e) => {
                  formik.setFieldValue("is_blocked", true);
                  formik.setFieldValue("is_warning", false);
                  formik.setFieldValue("action", e.target.checked);
                }}
              >
                Blocking
              </Radio>
              <Radio
                name="action"
                checked={formik.values.is_warning}
                onChange={(e) => {
                  formik.setFieldValue("is_warning", true);
                  formik.setFieldValue("is_blocked", false);
                  formik.setFieldValue("action", e.target.checked);
                }}
              >
                Warning
              </Radio>
            </div>
          </Panel>
          <div className="errorMsg">
            {formik.touched.action &&
              formik.errors.action &&
              "Blocking or Warning any one should be selected."}
          </div>
        </Collapse>

        <Button
          key="1"
          htmlType="submit"
          className="formButton mt3 primaryButton"
          disabled={createRes?.loading}
        >
          Save
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt3"
          onClick={() => {
            formik.resetForm();
            handleCancelButton();
          }}
        >
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default AddExpense;
